/*
 * VULCAN
 */
export var area = {
    parameterPath: "area",
    mapper: {
        required: true,
        serializedName: "area",
        type: {
            name: "String"
        }
    }
};
//# sourceMappingURL=parameters.js.map